<template>
  <div>
    <header class="bar bar-nav">
      <h1 class='title'>评价详情</h1>
    </header>

    <div class="content">
    <div class="card demo-card-header-pic" v-for="BOrderComment in BOrderComments">
      <div valign="bottom" class="card-header color-white no-border no-padding">
        <img class='card-cover' :src="baseurl + merch.merchandiseIcon">
      </div>
      <div class="card-content">
        <div class="card-content-inner">
          <p class="color-gray">发表于 {{BOrderComment.createDT}}</p>
          <p>{{BOrderComment.comments}}</p>
        </div>
      </div>
      <div>
        <div class="card-footer">
          <span>评价等级</span>
          <span style="float: right">
            <span class="icon icon-star" :class="{star : BOrderComment.commentLevel >=1}"></span>
          <span class="icon icon-star" :class="{star : BOrderComment.commentLevel >=2}"></span>
          <span class="icon icon-star" :class="{star : BOrderComment.commentLevel >=3}"></span>
          <span class="icon icon-star" :class="{star : BOrderComment.commentLevel >=4}"></span>
          <span class="icon icon-star":class="{star : BOrderComment.commentLevel >=5}"></span>
          </span>

        </div>
      </div>
    </div>
</div>
    </div>
  </div>
</template>
<script>
//  import $ from 'jquery'
  export default {
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/',
        BOrderComments: JSON.parse(this.$route.query.BOrderComments),
        merch: JSON.parse(this.$route.query.merch)
      }
    },
    mounted () {
//      var self = this
//      $(function () {
//        var s = document.getElementById('starts')
//        var n = s.getElementsByTagName('span')
//
//        for (var i = 0; i < n.length; i++) {
//          n[i].onclick = function () {
//            var q = +this.getAttribute('rel')
//            self.level = q
//            for (let i = q; i < n.length; i++) {
//              n[i].style = ''
//            }
//            for (let i = 0; i < q; i++) {
//              n[i].style = 'background-color: yellow'
//            }
//          }
//        }
//      })
    },
    methods: {
    }
  }
</script>
<style>
  .star {
    background-color: yellow;
  }
</style>



// WEBPACK FOOTER //
// GetComments.vue?d76dcfda